import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

class MeetingUserImage extends React.Component {

  constructor(props) {
    super(props)

    this.imageSource = this.imageSource.bind(this)
  }

  imageSource() {
    const src = this.props.otherUser.avatar_url
    if(src === 'medium/missing.png' || src == undefined) {
      return (
        <img
          className="missingImg"
          style={{width: 40, height: 40, borderRadius: 40/2}}
        />)
    }
    return (
      <img
        src={src}
        style={{width: 40, height: 40, borderRadius: 40/2}}
      />)
  }

  render() {

    return(
      <button
          style={{
            alignItems: 'center',
            cursor: 'pointer'
          }}
          onClick={() => window.location.assign(`/profile/${this.props.otherUser.slug}`)}
          >
          {this.imageSource()}
      </button>
    )
  }
}

export default MeetingUserImage;
